import BRANDS, { type BrandName } from "@elit-hair/brands";

/** Zoho CRM datacenter host per brand (US `.com` vs EU `.eu`). */
const ZOHO_CRM_HOST_BY_BRAND: Partial<Record<BrandName, string>> = {
    elithair: "crm.zoho.com",
    yessmile: "crm.zoho.eu",
    rhinomedica: "crm.zoho.eu",
};

/**
 * Generates a Zoho CRM record URL based on the brand, module type, and ID.
 * @param brand - The brand key (e.g. 'elithair').
 * @param moduleType - The module type ('Leads' | 'Contacts' | ...).
 * @param id - The ID of the record.
 * @returns The full URL as a string, or null if required params are missing.
 */
export function getZohoCrmUrl(
    brand: BrandName | undefined,
    moduleType: string | undefined,
    id: string | number | undefined
): string | null {
    if (!brand || !moduleType || !id) return null;
    const orgId = BRANDS[brand]?.zohoOrganizationId;
    const host = ZOHO_CRM_HOST_BY_BRAND[brand];
    if (!orgId || !host) return null;
    return `https://${host}/crm/${orgId}/tab/${moduleType}/${id}`;
}
